<template>
  <div class="isTxt" v-show="isTxt">
    {{ name || '-' }}
  </div>
  <DepartmentMultipleSelect
    v-show="!isTxt"
    :paramsData="commonParams"
    :api="api"
    :showValueData="showValueData"
    :disabled="isTxt || renderConfig.disabled"
    :isIncludeChild="isIncludeChild"
    :placeholder="renderConfig.placeholder"
    :collapseTags="true"
    @sure="getDep"
    @getDeptList="getDeptList"
    style="width: 100%"
  />
</template>

<script lang="ts" setup>
import { useNavHistory } from '@/stores/modules/routerNav'
import { recursion } from '@/utils/tools'
import { computed, ref, watch } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { getPageComponentData } from '@/apis/customerManage'
import { isArray, isNullOrUndefOrEmpty, isEmptyArray } from '@/utils/is'
import { getAssociatedData } from '@/components/custom/form/components/utils'
import { getPersonAnyDepDefaultValue } from '@/utils/render/defaultValue'
import { useDealAssociatedData } from '@/hooks/useDealAssociatedData'

const emit = defineEmits(['update:modelValue', 'refreshDataList', 'updadeViewData'])
const props = defineProps({
  ...basicProps,
  // 使用场景类型
  sceneType: {
    type: Number,
    default: 0
  },
  // 主表数据
  subFieldFormData: {
    type: Object as PropType<Recordable>,
    default: () => ({})
  }
})
const navHistory = useNavHistory()
const systemCode = navHistory.activeSysCode
// const showValueData = ref<Recordable[]>([])

const innerValue = computed({
  get() {
    return props.modelValue
  },
  set(newVal) {
    if (isNullOrUndefOrEmpty(newVal) || isEmptyArray(newVal)) {
      getName([])
    }
    emit('update:modelValue', newVal)
  }
})
let name = ref('')
function getName(list: any) {
  const arr: string[] = []
  list.forEach(item => {
    arr.push(item.name)
  })
  name.value = arr.length ? arr.join(',') : '-'
}

const isIncludeChild = ref<boolean>(props.isTxt || props.isIncludeChild)

const showValueData = computed(() => {
  let value: Recordable[] = []
  // console.log(innerValue.value, 'innerValue')
  if (innerValue.value) {
    if (!isArray(innerValue.value)) {
      value = innerValue.value.split(',').map((item: Recordable) => ({ id: item }))
    } else {
      value = innerValue.value?.map((item: Recordable) => ({ id: item }))
    }
  }
  return value
})

const api = computed(() => {
  return props?.renderConfig?.api || getPageComponentData
})

const commonParams = {
  columnId: props.data.id,
  columnUseScene: props.data.columnUseScene,
  tableCode: props.data.tableCode,
  memberType: props.data.memberType,
  checkChildFlag: props.data.checkChildFlag,
  useSceneType: props.data.useSceneType,
  extraAgreements: {
    systemCode: systemCode,
    containChildren: 1,
    useSceneType: props.data.useSceneType,
    disableDeptIds: !isArray(innerValue.value) ? innerValue.value.split(',') : innerValue.value
  }
}

function getDep(data: Recordable) {
  console.log(data, '部门多选')
  let depIds: Recordable[] = []
  let depList: Recordable[] = []
  if (data.containChildren) {
    // 不包含
    depIds = data.departmentList.map((item: Recordable) => item.id) || []
    depList = data.departmentList
  } else {
    recursion(data.departmentList, item => {
      depIds.push(item.id)
      depList.push(item)
    })
  }
  console.log(depIds, 'depIds')
  emit('update:modelValue', depIds.join(','))
  console.log(innerValue.value, 'innerValue.valueinnerValue.value')
  emit('refreshDataList', data.departmentList)
  // isIncludeChild.value = data.containChildren
  // showValueData.value = data.departmentList.map((item: Recordable) => {return { id: item.id }})
  innerValue.value = depIds.join(',')
}

function getDeptList(data: Recordable) {
  if (!isNullOrUndefOrEmpty(data)) {
    getName(data)
    emit('refreshDataList', data)
    emit('updadeViewData', innerValue.value)
  }
}

watch(
  () => props.isTxt,
  val => {
    if (!val && props.modelValue === '') {
      emit('update:modelValue', getPersonAnyDepDefaultValue(props) || '')
    }
  },
  { immediate: true }
)

// 回显值获取函数(关联已有数据)
const getFetchAssociatedData = () => {
  return getAssociatedData(props).then((res: Recordable) => {
    innerValue.value = res?.value || ''
    return res
  })
}

watch(
  // 避免新值和旧值一样的情况(监听"引用类型")
  () => JSON.parse(JSON.stringify(props.formData)),
  (newFormData, oldFormData) => {
    useDealAssociatedData(props, oldFormData, getFetchAssociatedData)
  },
  { immediate: true, deep: true }
)
</script>

<style lang="scss" scoped></style>
